import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Wrapper from "@/timvir/wrapper";
const MDXLayout = Wrapper;
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "@timvir/hooks"
    }), "\n", _jsxs("div", {
      style: {
        fontSize: "1.1em",
        margin: "24px -16px .5em",
        padding: "6px 16px 3px",
        background: "var(--c-p-0)",
        borderBottom: "2px solid var(--c-p-2)"
      },
      children: [_jsx("span", {
        style: {
          color: "var(--timvir-secondary-text-color)"
        },
        children: "hook"
      }), _jsx("span", {
        style: {
          fontWeight: 500
        },
        children: "useResizeObserver"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  return _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  });
}
